import React from "react";
import { Modal, Row, Col } from "antd";
import { getCarName, formatRupiah } from "../../../../Utils";

const RowForm = props => (
  <Row style={{ padding: " 5px 10px" }}>{props.children}</Row>
);

class ModalConfirmOdoo extends React.Component {
  state = {
    modalSendToOdoo: false,
  };

  render() {
    const { data } = this.props;
    const { Appraisal } = data;
    let carName,
      Booking,
      SalesProfile,
      SalesBranch,
      Supervisor,
      Appraiser,
      licensePlate;

    if (Appraisal) {
      carName = getCarName(Appraisal.carDetail);
      Appraiser = Appraisal.Appraiser;
      Booking = Appraisal.Booking;
      licensePlate = Appraisal.licensePlate;
      if (Booking) {
        SalesProfile = Booking.SalesProfile;
        if (SalesProfile) {
          SalesBranch = SalesProfile.SalesBranch;
          Supervisor = SalesProfile.Supervisor;
        }
      }
    }

    return (
      <Modal
        title="Data Send To Odoo"
        visible={this.props.visible}
        confirmLoading={this.props.confirmLoading}
        onOk={() => this.setState({ modalSendToOdoo: true })}
        onCancel={() => this.props.visibleModal("Confirm", false)}
        okText="Confirm"
        width={700}>
        <p>Detail Approval</p>

        <RowForm>
          <Col span={8}>No Booking</Col>
          <Col span={16}>: {Booking ? Booking.noBooking : null}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Cabang</Col>
          <Col span={16}>: {SalesBranch ? SalesBranch.branch : null}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Kepala Cabang</Col>
          <Col span={16}>
            :{" "}
            {SalesBranch
              ? SalesBranch.Kacab
                ? SalesBranch.Kacab.name
                : null
              : null}
          </Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Nama Supervisor</Col>
          <Col span={16}>: {Supervisor ? Supervisor.name : null}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Nama Sales</Col>
          <Col span={16}>: {SalesProfile ? SalesProfile.name : null}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Nama Appraiser</Col>
          <Col span={16}>: {Appraiser ? Appraiser.name : null}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Nama Mobil</Col>
          <Col span={16}>: {carName}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Nomor Polisi</Col>
          <Col span={16}>: {licensePlate || null}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Harga Deal</Col>
          <Col span={16}>: {formatRupiah(data.finalPrice)}</Col>
        </RowForm>

        {/* Modal Confirm */}
        <Modal
          title="Konfirmasi"
          visible={this.state.modalSendToOdoo}
          onOk={() =>
            this.setState({ modalSendToOdoo: false }, () =>
              this.props.sendButton(data ? data.id : null)
            )
          }
          onCancel={() => this.setState({ modalSendToOdoo: false })}
          okText="Submit"
          width={400}>
          Apakah anda yakin mengirim ke Odoo?
        </Modal>
      </Modal>
    );
  }
}

export default ModalConfirmOdoo;



// WEBPACK FOOTER //
// src/components/Dashboard/Approval/Component/Modal/ModalConfirmOdoo.js